import React from "react";

const SourceMarker = ({ width = 33.997, height = 42 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 33.997 42"
    >
      <g transform="translate(-135.004 -227)">
        <ellipse
          cx="5"
          cy="1"
          fill="#2a2e43"
          opacity="0.5"
          rx="5"
          ry="1"
          transform="translate(147 264)"
        />
        <path
          fill="#3278d7"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2px"
          d="M274.994 256.111a14.9 14.9 0 0 0-1.468-6.206 15.153 15.153 0 0 0-1.335-2.252 15.7 15.7 0 0 0-4.112-3.953 16.2 16.2 0 0 0-2.092-1.169l-.134.128.134-.128a16.756 16.756 0 0 0-12.349-.652 15.862 15.862 0 0 0-8.368 6.576l.124.12-.124-.119a14.925 14.925 0 0 0-.671 14.634 15.723 15.723 0 0 0 6.6 6.72q.513.275 1 .587a14.776 14.776 0 0 1 4.172 3.929l1.479 2.093a1.411 1.411 0 0 0 2.282 0l1.548-2.189a14.464 14.464 0 0 1 5.048-4.39 15.282 15.282 0 0 0 8.266-13.729z"
          transform="translate(-106.996 -13)"
        />
      </g>
    </svg>
  );
};

export default SourceMarker;
